import React from 'react';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import { Skeleton } from '@material-ui/lab';

export default function AttendanceComponent(props) {
  const arrayOfData = () => {
    const month = [];
    const absent = [];
    const present = [];
    const total = [];
    const Data = {
      month: month,
      absent: absent,
      present: present,
      total: total,
    };
    props.tableData &&
      props.tableData.map((item) => {
        item.attendance.map((data) => {
          month.push(`${data.Month}-${parseYear(item.year + '')}`);
          absent.push(data.Absent);
          present.push(data.Present);
          total.push(data.Total);
        });
      });
    Data.month = month;
    Data.absent = absent;
    Data.present = present;
    Data.total = total;
    return Data;
  };

  const parseYear = (str) => {
    if (str && str != ' ') {
      return str.substring(str.length - 2, str.length);
    }
    return '';
  };

  const populateTable = () => {
    const dummyData = {
      month: [1, 1, 1, 1, 1, 1, 1, 1],
      total: [1, 1, 1, 1, 1, 1, 1, 1],
      present: [1, 1, 1, 1, 1, 1, 1, 1],
      absent: [1, 1, 1, 1, 1, 1, 1, 1],
    };
    const data = props.isFetching ? dummyData : arrayOfData();
    return (
      <Table stickyHeader size="small" className="attendance-table">
        <TableHead>
          <TableRow>
            <TableCell>Month</TableCell>
            <>
              {data.month.map((item, index) => {
                return (
                  <TableCell size="small" align="center" key={index}>
                    {props.isFetching ? <Skeleton /> : item}
                  </TableCell>
                );
              })}
            </>
          </TableRow>
        </TableHead>
        <TableRow>
          <TableCell>Total</TableCell>
          <>
            {data.total.map((item, index) => {
              return (
                <TableCell size="small" align="center" key={index}>
                  {props.isFetching ? <Skeleton /> : item}
                </TableCell>
              );
            })}
          </>
        </TableRow>
        <TableRow>
          <TableCell>Present</TableCell>
          <>
            {data.present.map((item, index) => {
              return (
                <TableCell size="small" align="center" key={index}>
                  {props.isFetching ? <Skeleton /> : item}
                </TableCell>
              );
            })}
          </>
        </TableRow>
        <TableRow>
          <TableCell>Absent</TableCell>
          <>
            {data.absent.map((item, index) => {
              return (
                <TableCell size="small" align="center" key={index}>
                  {props.isFetching ? <Skeleton /> : item}
                </TableCell>
              );
            })}
          </>
        </TableRow>
      </Table>
    );
  };
  return (
    <React.Fragment>
      <TableContainer className="table-container scroll-table">
        {populateTable()}
        <PerfectScrollbar></PerfectScrollbar>
      </TableContainer>
    </React.Fragment>
  );
}
AttendanceComponent.propTypes = {
  tableData: PropTypes.object,
  isFetching: PropTypes.bool,
};
